import Attachment from 'models/Attachment';
import { WorkflowAttachmentOptions } from 'models/Workflow';

// A referral's own document as the model the attachment row renders, so a document already
// attached and one just added look and behave the same in one list. The workflow carries the
// packet as `{id, filename, docType}` objects; Attachment reads its name off the blob.
export function packetAttachment(
  entry: Pick<WorkflowAttachmentOptions, 'id' | 'filename'> & { docType?: string | null }
) {
  return new Attachment({
    id: entry.id,
    docType: entry.docType ?? null,
    blob: { id: '', signedId: '', filename: entry.filename ?? '', contentType: '', metadata: {} },
  });
}
